// Test IDs for the TravelBook travel app — used by the e2e testing agent.
// Keys are camelCase, values kebab-case `<feature>-<element>`.

export const AUTH = {
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  nameInput: 'auth-name-input',
  submitBtn: 'auth-submit-btn',
  toggleModeBtn: 'auth-toggle-mode-btn',
  error: 'auth-error',
  logoutBtn: 'auth-logout-btn',
  googleBtn: 'auth-google-btn',
};

export const NAV = {
  tabExplore: 'nav-tab-explore',
  tabDream: 'nav-tab-dream',
  tabChapters: 'nav-tab-chapters',
  tabPassport: 'nav-tab-passport',
  tabLounge: 'nav-tab-lounge',
  adminLink: 'nav-admin-link',
};

export const ADMIN = {
  page: 'admin-page',
  kpiUsers: 'admin-kpi-users',
  kpiClicks: 'admin-kpi-clicks',
  kpiRevenue: 'admin-kpi-revenue',
  kpiSaves: 'admin-kpi-saves',
  topDestinationsTable: 'admin-top-destinations',
  funnelChart: 'admin-funnel',
  topPostsList: 'admin-top-posts',
  recentClicks: 'admin-recent-clicks',
  backBtn: 'admin-back-btn',
  digestCard: 'admin-digest-card',
  digestSendBtn: 'admin-digest-send-btn',
  digestPreviewBtn: 'admin-digest-preview-btn',
  digestHistory: 'admin-digest-history',
  destMaintCard: 'admin-dest-maint-card',
  destMaintStats: 'admin-dest-maint-stats',
  destMaintBackfillBtn: 'admin-dest-maint-backfill-btn',
  destMaintForceBtn: 'admin-dest-maint-force-btn',
  destMaintConfirmDialog: 'admin-dest-maint-confirm-dialog',
  destMaintConfirmYes: 'admin-dest-maint-confirm-yes',
  destMaintConfirmCancel: 'admin-dest-maint-confirm-cancel',
  addDestCard: 'admin-add-dest-card',
  addDestNameInput: 'admin-add-dest-name',
  addDestTypeSelect: 'admin-add-dest-type',
  addDestCityInput: 'admin-add-dest-city',
  addDestStateInput: 'admin-add-dest-state',
  addDestCountryInput: 'admin-add-dest-country',
  addDestAddressInput: 'admin-add-dest-address',
  addDestLatInput: 'admin-add-dest-lat',
  addDestLngInput: 'admin-add-dest-lng',
  addDestCategoryInput: 'admin-add-dest-category',
  addDestTagsInput: 'admin-add-dest-tags',
  addDestDescriptionInput: 'admin-add-dest-description',
  addDestImageInput: 'admin-add-dest-image',
  addDestSubmitBtn: 'admin-add-dest-submit',
  addDestDuplicateBtn: 'admin-add-dest-duplicate',
  addDestRecentList: 'admin-add-dest-recent-list',
  addDestRecentDelete: (id) => `admin-add-dest-recent-delete-${id}`,
  addDestRecentRetry: (id) => `admin-add-dest-recent-retry-${id}`,
  addDestRecentOverrideBtn: (id) => `admin-add-dest-recent-override-btn-${id}`,
  addDestRecentOverrideInput: (id) => `admin-add-dest-recent-override-input-${id}`,
  addDestRecentOverrideSubmit: (id) => `admin-add-dest-recent-override-submit-${id}`,
};

export const EXPLORE = {
  // Filter landing screen
  filtersPage: 'explore-filters-page',
  filterRegion: (r) => `explore-region-${r}`,
  filterCategory: (c) => `explore-category-${c}`,
  budgetSlider: 'explore-budget-slider',
  budgetPreset: (b) => `explore-budget-${b}`,
  locationInput: 'explore-location-input',
  budgetSelect: 'explore-budget-select',
  currencySelect: 'explore-currency-select',
  clearFiltersBtn: 'explore-clear-filters-btn',
  startSwipingBtn: 'explore-start-swiping-btn',
  goToBookmarksBtn: 'explore-go-to-bookmarks-btn',
  matchCount: 'explore-match-count',

  // Discovery deck screen
  deckPage: 'explore-deck-page',
  backToFiltersBtn: 'explore-back-to-filters-btn',
  backBtn: 'explore-back-btn',
  undoBtn: 'explore-undo-btn',
  card: 'explore-card',
  skipBtn: 'explore-skip-btn',
  bookmarkBtn: 'explore-bookmark-btn',
  saveBtn: 'explore-save-btn',
  bookBtn: 'explore-book-btn',
  resetBtn: 'explore-reset-btn',
  emptyState: 'explore-empty-state',

  // Bookmarks grid
  bookmarksPage: 'explore-bookmarks-page',
  bookmarkCard: (id) => `explore-bookmark-card-${id}`,
  bookmarkBookBtn: (id) => `explore-bookmark-book-${id}`,
  bookmarkDreamBtn: (id) => `explore-bookmark-dream-${id}`,
  bookmarksEmpty: 'explore-bookmarks-empty',
};

export const DREAM = {
  page: 'dream-page',
  // Multi-vacation additions (Phase 2)
  listPage: 'dream-list-page',
  detailPage: 'dream-detail-page',
  card: (id) => `dream-card-${id}`,
  createBtn: 'dream-create-btn',
  emptyState: 'dream-empty-state',
  newTitleInput: 'dream-new-title-input',
  newSubmit: 'dream-new-submit',
  backToList: 'dream-back-to-list',
  titleEdit: 'dream-title-edit',
  titleInput: 'dream-title-input',
  saveTitleBtn: 'dream-save-title-btn',
  // Legacy (still used inside the detail page)
  destinationName: 'dream-destination-name',
  jar: 'dream-money-jar',
  savedAmount: 'dream-saved-amount',
  addAmount: (n) => `dream-add-${n}`,
  subtractAmount: (n) => `dream-subtract-${n}`,
  subtractToggle: 'dream-subtract-toggle',
  moodBoard: 'dream-moodboard',
  pickDestinationBtn: 'dream-pick-destination-btn',
  destinationOption: (id) => `dream-destination-option-${id}`,
  // Itinerary
  itinerary: 'dream-itinerary',
  itineraryDay: (d) => `dream-itinerary-day-${d}`,
  itineraryItem: (id) => `dream-itinerary-item-${id}`,
  itineraryRemoveItem: (id) => `dream-itinerary-remove-${id}`,
  itineraryAddOpen: (d) => `dream-itinerary-add-open-${d}`,
  itineraryAddDayBtn: 'dream-itinerary-add-day',
  itineraryAddTitle: 'dream-itinerary-add-title',
  itineraryAddType: 'dream-itinerary-add-type',
  itineraryAddTime: 'dream-itinerary-add-time',
  itineraryAddNotes: 'dream-itinerary-add-notes',
  itineraryAddUrl: 'dream-itinerary-add-url',
  itineraryAddSubmit: 'dream-itinerary-add-submit',
  // Delete (item #35)
  cardDeleteBtn: (id) => `dream-card-delete-${id}`,
  detailDeleteBtn: 'dream-detail-delete-btn',
  deleteConfirmDialog: 'dream-delete-confirm-dialog',
  deleteConfirmSubmit: 'dream-delete-confirm-submit',
  deleteConfirmCancel: 'dream-delete-confirm-cancel',
};

export const PASSPORT = {
  page: 'passport-page',
  stamp: (code) => `passport-stamp-${code}`,
  achievementsList: 'passport-achievements',
  achievement: (id) => `passport-achievement-${id}`,
  // Rewards section
  rewardsCard: 'passport-rewards-card',
  rewardsBalance: 'passport-rewards-balance',
  rewardsTier: 'passport-rewards-tier',
  earnMethod: (id) => `passport-earn-${id}`,
  redeemBtn: (id) => `passport-redeem-${id}`,
  redeemCard: (id) => `passport-redeem-card-${id}`,
  referOpen: 'passport-refer-open',
  referEmail: 'passport-refer-email',
  referSubmit: 'passport-refer-submit',
};

export const CHAPTERS = {
  page: 'chapters-page',
  yearTab: (y) => `chapters-year-${y}`,
  entry: (id) => `chapters-entry-${id}`,
};

export const LOUNGE = {
  page: 'lounge-page',
  post: (id) => `lounge-post-${id}`,
  likeBtn: (id) => `lounge-like-${id}`,
  commentBtn: (id) => `lounge-comment-${id}`,
  reportBtn: (id) => `lounge-report-${id}`,
  newPostBtn: 'lounge-new-post-btn',
  newPostText: 'lounge-new-post-text',
  newPostLocation: 'lounge-new-post-location',
  newPostImage: 'lounge-new-post-image',
  newPostSubmit: 'lounge-new-post-submit',
};

export const NOTIF = {
  page: 'notifications-page',
  bellBtn: 'nav-notif-bell',
  unreadDot: 'notif-unread-dot',
  unreadBadge: 'notif-unread-badge',
  item: (id) => `notif-item-${id}`,
  empty: 'notif-empty',
  markAllRead: 'notif-mark-all-read',
  clearAll: 'notif-clear-all',
};
